var _path, _circle, _circle2, _use, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAsean = function SvgAsean(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    viewBox: "0 0 512 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0039a6",
    d: "M0 0h512v512H0z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 153.6,
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 146.4,
    fill: "#ed2939"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#asean_svg__a",
    transform: "matrix(-1 0 0 1 512 0)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "asean_svg__a",
    fill: "#f9e300"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M295.424 256c25.6-15.36 37.376-46.08 37.376-76.8h-11.776v1.024c0 10.24-1.536 47.616-29.696 75.776a112.64 112.64 0 0 1 29.696 75.776v1.024H332.8c0-30.72-12.288-61.44-37.376-76.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.44 180.224V179.2h-12.288v1.536c0 10.24-2.048 46.08-22.016 75.264 20.48 29.184 22.016 65.024 22.016 75.264v1.536h12.288v-1.024c0-10.24-2.56-47.616-29.696-75.776a112.64 112.64 0 0 0 29.696-75.776"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m278.528 256 1.024-1.024a138.24 138.24 0 0 0 21.504-74.24V179.2h-11.264v2.048c0 10.752-1.536 45.056-15.36 74.752a194.6 194.6 0 0 1 15.36 74.752v2.048h11.264v-1.536c0-10.24-1.024-42.496-21.504-74.24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.336 256a189.4 189.4 0 0 0 15.36-76.8H273.92v3.584c0 12.8-1.024 44.032-7.68 73.216a358.4 358.4 0 0 1 7.68 73.216v3.584h11.264v-2.048c0-10.752-1.024-46.08-14.336-74.24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.144 256a353.3 353.3 0 0 0 7.168-73.216V179.2h-11.264v153.6h11.264v-3.584c0-12.288 0-44.032-7.168-72.704"
  }))));
};
export default SvgAsean;